import React from "react"
import ErrorLayout from "@layouts/error-layout"

const NotFound = () => <ErrorLayout code="404" text="Whoops, it looks like you're lost" />

export default NotFound
